<template>
  <b-container class="padding-lr-none">
    <b-row>
      <b-col cols="12">
         <label for="textarea-large" class="title__name text-large">Observaciones del cliente</label>
        <b-form-textarea
          v-bind:value="value"
          v-on:input="$emit('input', $event)"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="
            padding-ten-all
            border-radius-22
            text-medium
            padding-three-left padding-two-top
          "
        ></b-form-textarea>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "ObservationInput",
  props: ["value"],
};
</script>
<style scoped>
</style>